import { Option } from '../../general-types';
import { ValueOfKey } from '../../utils-types';

// use getHumanizeReleasePlatform utils to get showed name

export const RELEASE_PLATFORM = {
  APP: 'APP',
  DASHBOARD: 'DASHBOARD',
  RESOURCES: 'RESOURCES',
  BUSINESS_CENTER: 'BUSINESS_CENTER',
} as const;

export type ReleasePlatformType = ValueOfKey<typeof RELEASE_PLATFORM>;

export const humanizeReleasePlatform: Record<ReleasePlatformType, string> = {
  APP: 'App',
  DASHBOARD: 'Dashboard',
  RESOURCES: 'Resources',
  BUSINESS_CENTER: 'Business Center',
};

export const platformFilterOptions: Option<ReleasePlatformType>[] = [
  { label: 'App', value: 'APP' },
  { label: 'Dashboard', value: 'DASHBOARD' },
  { label: 'Resources', value: 'RESOURCES' },
  { label: 'Business Center', value: 'BUSINESS_CENTER' },
];
